{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2018 - 2020                               }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.ComCtrls;

interface

uses
  Classes, SysUtils, Web, WEBLib.Controls, WEBLib.Graphics, WEBLib.ExtCtrls,
  WEBLib.TreeNodes;

type
  TCustomRichEdit = class;

  TTextAttributes = class(TPersistent)
  private
    RichEdit: TCustomRichEdit;
    FAlignment: TAlignment;
    FIsBold: Boolean;
    FIsItalic: Boolean;
    FIsUnderline: Boolean;
    FIsStrikeOut: Boolean;
    FBackColor: TColor;
    FColor: TColor;
    FHeight: Integer;
    FName: String;
    FOrderedList: Boolean;
    FSize: Integer;
    FStyle: TFontStyles;
    FUnOrderedList: Boolean;
    procedure SetAlignment(Value: TAlignment);
    procedure SetBackColor(Value: TColor);
    procedure SetColor(Value: TColor);
    procedure SetHeight(Value: Integer);
    procedure SetName(Value: String);
    procedure SetOrderedList(Value: Boolean);
    procedure SetSize(Value: Integer);
    procedure SetStyle(Value: TFontStyles);
    procedure SetUnOrderedList(Value: Boolean);
  protected
    procedure AssignTo(Dest: TPersistent); override;
  public
    constructor Create(AOwner: TCustomRichEdit); reintroduce;
    procedure Assign(Source: TPersistent); override;
    procedure Cut;
    procedure Copy;
    procedure Paste;
    procedure Image;
    procedure Link;
    property Alignment: TAlignment read FAlignment write SetAlignment;
    property BackColor: TColor read FBackColor write SetBackColor;
    property Color: TColor read FColor write SetColor;
    property Height: Integer read FHeight write SetHeight;
    property Name: String read FName write SetName;
    property OrderedList: Boolean read FOrderedList write SetOrderedList;
    property Size: Integer read FSize write SetSize;
    property Style: TFontStyles read FStyle write SetStyle;
    property UnOrderedList: Boolean read FUnOrderedList write SetUnOrderedList;
  end;

  TCustomRichEdit = class(TCustomControl)
  private
    FOwner: TCustomControl;
    FLines: TStringList;
    FSelAttributes: TTextAttributes;
    FAutoSize: Boolean;
    FOnSelectionChange: TNotifyEvent;
    FShowFocus: boolean;
    FInsertLineBreaks: boolean;
    FWantTabs: boolean;
    FReadOnly: boolean;
    FOnChange: TNotifyEvent;
    function GetText: String;
    function GetPlainText: String;
    procedure SetText(const Value: String);
    procedure SetSelAttributes(Value: TTextAttributes);
    procedure SetAutoSize(const Value: Boolean);
    procedure SetShowFocus(const Value: boolean); reintroduce;
    procedure SetReadOnly(const Value: boolean);
  protected
    function CreateElement: TJSElement; override;
//    function ElementIFrameHandle: TJSWindow;
    function ElementIFrameHandle: TJSDocument;
    procedure UpdateElement; override;
    procedure Loaded; override;
    function CanShowFocus: boolean; override;
    procedure DoHandleInput(Event: TJSEvent); virtual;
    function HandleDoSelectionChange(Event: TEventListenerEvent): Boolean; virtual;
    function HandleDoKeyDown(Event: TJSKeyBoardEvent): Boolean; override;
    procedure SetLines(ALines: TStringList);
    procedure DoLinesChange(Sender: TObject);
    property Text: String read GetText write SetText;
    property Font;
    property Color;
    property BorderStyle;
    property AutoSize: Boolean read FAutoSize write SetAutoSize default false;
    property Lines: TStringList read FLines write SetLines;
    property OnClick;
    property OnDblClick;
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
    property OnSelectionChange: TNotifyEvent read FOnSelectionChange write FOnSelectionChange;
    property PlainText: String read GetPlainText;
    procedure DoEditAction(ActionString: string); overload;
    procedure DoEditAction(ActionString: string; Data: string); overload;
    procedure DoChange; virtual;
  public
    procedure CreateInitialize; override;
    destructor Destroy; override;

    function GetContent: string;
    procedure DoSelectAction(StartPosition, EndPosition: integer);
    procedure DoImageAction;
    procedure DoLinkAction;
    procedure InsertHTML(HTML: String);

    property InsertLineBreaks: boolean read FInsertLineBreaks write FInsertLineBreaks default false;
    property SelAttributes: TTextAttributes read FSelAttributes write SetSelAttributes;
    property ShowFocus: boolean read FShowFocus write SetShowFocus default true;
    property Owner: TCustomControl read FOwner write FOwner;
    property ReadOnly: boolean read FReadOnly write SetReadOnly default false;
    property WantTabs: boolean read FWantTabs write FWantTabs default false;
  end;

  TRichEdit = class(TCustomRichEdit)
  public
    property Owner;
    property PlainText;
  published
    property Align;
    property AlignWithMargins;
    property Anchors;
    property AutoSize;
    property ElementClassName;
    property ElementFont;
    property ElementID;
    property ElementPosition;
    property Font;
    property Color;
    property BorderStyle;
    property Height;
    property HeightPercent;
    property HeightStyle;
    property InsertLinebreaks;
    property Lines;
    property Margins;
    property ReadOnly;
    property WantTabs;
    property Width;
    property WidthPercent;
    property WidthStyle;
    property OnChange;
    property OnClick;
    property OnDblClick;
    property OnSelectionChange;
    property OnKeyDown;
    property OnKeyPress;
    property OnKeyUp;
    property OnMouseDown;
    property OnMouseUp;
    property OnMouseMove;
    property OnMouseLeave;
    property OnMouseEnter;
    property OnEnter;
    property OnExit;
  end;

  TWebRichEdit = class(TRichEdit);

  TTabSet = class(TCustomControl)
  private
    FItems: TStringList;
    FItemIndex: integer;
    FSelectedColor: TColor;
    FOnChange: TNotifyEvent;
    procedure SetSelectedColor(const Value: TColor);
  protected
    function CreateElement: TJSElement; override;
    function HandleDoClick(Event: TJSMouseEvent): Boolean; override;
    function HandleDoChange(Event: TEventListenerEvent): Boolean; virtual;
    function HandleDoItemMouseOut(Event: TJSMouseEvent): Boolean; virtual;
    function HandleDoItemMouseOver(Event: TJSMouseEvent): Boolean; virtual;
    procedure BindEvents; override;
    procedure SetItems(AItems: TStringList);
    procedure SetItemIndex(AIndex: integer);
    procedure DoUpdateList; virtual;
    procedure Loaded; override;
    procedure ItemsChanged(Sender: TObject);
  public
    procedure CreateInitialize; override;
    destructor Destroy; override;
    procedure EndUpdate; override;
    procedure Clear;
    procedure SelectNextTab(GoForward: boolean);
  published
    property Align;
    property AlignWithMargins;
    property Anchors;
    property Color;
    property ElementClassName;
    property ElementFont;
    property ElementID;
    property ElementPosition;
    property Enabled;
    property Font;
    property Height;
    property HeightPercent;
    property HeightStyle;
    property Hint;
    property ItemIndex: integer read FItemIndex write SetItemIndex;
    property Items: TStringList read FItems write SetItems;
    property Left;
    property Margins;
    property ParentFont;
    property ShowHint;
    property SelectedColor: TColor read FSelectedColor write SetSelectedColor default clSilver;
    property TabOrder;
    property TabStop;
    property Top;
    property Visible;
    property Width;
    property WidthPercent;
    property WidthStyle;
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
    property OnClick;
    property OnDblClick;
    property OnKeyDown;
    property OnKeyPress;
    property OnKeyUp;
    property OnMouseDown;
    property OnMouseUp;
    property OnMouseMove;
    property OnMouseLeave;
    property OnMouseEnter;
    property OnEnter;
    property OnExit;
  end;

  TWebTabSet = class(TTabSet);

  TTabSheet = class(TPanel)
  private
    FTabVisible: Boolean;
    FTabCaption: string;
    procedure SetTabVisible(const Value: Boolean);
  protected
    procedure SetCaption(const AValue: string); override;
  public
    procedure CreateInitialize; override;
  published
    property TabVisible: Boolean read FTabVisible write SetTabVisible default True;
    property Visible;
  end;

  TWebTabSheet = class(TTabSheet);

  TPageControl = class(TCustomControl)
  private
    FPrevTabIndex: Integer;
    FItems: TStringList;
    FTabIndex: Integer;
    FSelectedColor: TColor;
    FOnChange: TNotifyEvent;
    procedure SetSelectedColor(const AValue: TColor);
    procedure SetItems(AItems: TStringList);
    procedure SetTabIndex(AIndex: integer);
  protected
    function GetPage(Index: integer): TTabSheet;
    function CreateElement: TJSElement; override;
    function HandleDoClick(Event: TJSMouseEvent): Boolean; override;
    function HandleDoChange(Event: TJSMouseEvent): Boolean; virtual;
    function HandleDoItemMouseOut(Event: TJSMouseEvent): Boolean; virtual;
    function HandleDoItemMouseOver(Event: TJSMouseEvent): Boolean; virtual;
    procedure BindEvents; override;
    procedure DoUpdateList; virtual;
    procedure Loaded; override;
  public
    procedure CreateInitialize; override;
    destructor Destroy; override;
    procedure Clear;
    procedure EndUpdate; override;
    procedure SelectNextPage(GoForward: boolean);
    function PageCount: integer;
    property Pages[index: integer]: TTabSheet read GetPage;
  published
    property Align;
    property AlignWithMargins;
    property Anchors;
    property BorderStyle;
    property ElementClassName;
    property ElementFont;
    property ElementID;
    property ElementPosition;
    property Enabled;
    property Font;
    property Height;
    property HeightPercent;
    property HeightStyle;
    property Hint;
    property TabIndex: integer read FTabIndex write SetTabIndex;
    property Items: TStringList read FItems write SetItems;
    property Left;
    property Margins;
    property ParentFont;
    property ShowHint;
    property SelectedColor: TColor read FSelectedColor write SetSelectedColor;
    property TabOrder;
    property TabStop;
    property Top;
    property Visible;
    property Width;
    property WidthPercent;
    property WidthStyle;
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
    property OnClick;
    property OnDblClick;
    property OnKeyDown;
    property OnKeyPress;
    property OnKeyUp;
    property OnMouseDown;
    property OnMouseUp;
    property OnMouseMove;
    property OnMouseLeave;
    property OnMouseEnter;
    property OnEnter;
    property OnExit;
  end;

  TWebPageControl = class(TPageControl);

  TProgressBarStyle = (pbstNormal, pbstMarquee, pbstDiv);
  TProgressBarValue = (pbvNone, pbvPercentage, pbvAbsolute);

  TProgressBar = class(TCustomControl)
  private
    FMax: integer;
    FMin: integer;
    FPosition: integer;
    FStyle: TProgressBarStyle;
    FElementBarClassName: string;
    FValue: TProgressBarValue;
    procedure SetStyle(const Value: TProgressBarStyle);
    procedure SetElementBarClassName(const Value: string);
    procedure SetValue(const Value: TProgressBarValue);
  protected
    function CreateElement: TJSElement; override;
    procedure SetMax(AValue: integer);
    procedure SetMin(AValue: integer);
    procedure SetPosition(AValue: integer);
    procedure DoUpdate; virtual;
    procedure CreateProgressElement(AElement: TJSElement);
  public
    procedure CreateInitialize; override;
    procedure AfterLoadDFMValues; override;
  published
    property Align;
    property AlignWithMargins;
    property Anchors;
    property ElementBarClassName: string read FElementBarClassName write SetElementBarClassName;
    property ElementPosition;
    property Height;
    property HeightPercent;
    property HeightStyle;
    property Left;
    property Margins;
    property Max: integer read FMax write SetMax;
    property Min: integer read FMin write SetMin;
    property Position: integer read FPosition write SetPosition;
    property Style: TProgressBarStyle read FStyle write SetStyle;
    property Top;
    property Value: TProgressBarValue read FValue write SetValue;
    property Visible;
    property Width;
    property WidthPercent;
    property WidthStyle;
  end;

  TWebProgressBar = class(TProgressBar);

  TTreeViewNodeEvent = procedure(Sender: TObject; Node: TTreeNode) of object;
  TTreeViewNodeAllowEvent = procedure(Sender: TObject; Node: TTreeNode; var Allow: boolean) of object;

  TTreeViewNodeRenderEvent = procedure(Sender: TObject; Node: TTreeNode; AElement: TJSHTMLElement) of object;

  TTreeView = class(TCustomControl)
  private
    FItems: TTreeNodes;
    FSelected: TTreeNode;
    FOnCollapsing: TTreeViewNodeAllowEvent;
    FOnExpanding: TTreeViewNodeAllowEvent;
    FOnCollapsed: TTreeViewNodeEvent;
    FOnExpanded: TTreeViewNodeEvent;
    FOnClickNode: TTreeViewNodeEvent;
    FOnDblClickNode: TTreeViewNodeEvent;
    FOnRenderNode: TTreeViewNodeRenderEvent;
    FAutoExpand: boolean;
    FOnChange: TTreeViewNodeEvent;
    FOnChanging: TTreeViewNodeAllowEvent;
    FElementNodeSelectedClassName: TElementClassName;
    FElementNodeClassName: TElementClassName;
    procedure SetItems(const Value: TTreeNodes);
    function GetSelected: TTreeNode;
    procedure SetSelected(const Value: TTreeNode);
    procedure SetElementNodeClassName(const Value: TElementClassName);
    procedure SetElementNodeSelectedClassName(const Value: TElementClassName);
  protected
    procedure DoRenderNode(ANode: TTreeNode; AElement: TJSHTMLElement);
    function RenderNode(ANode: TTreeNode; AElementName: string): TJSHTMLElement;
    procedure RenderNodes;
    function CreateElement: TJSElement; override;
    procedure DoNodesChanged(Sender: TObject);
    procedure DoExpandedChanged(Sender: TObject; ANode: TTreeNode);
    function HandleNode(Event: TJSEvent): Boolean; virtual;
    function HandleClick(Event: TJSEvent): Boolean; virtual;
    function HandleDblClick(Event: TJSEvent): Boolean; virtual;
    procedure KeyDown(var Key: Word; Shift: TShiftState); override;
    procedure DoChangeSelection(NewNode: TTreeNode); virtual;
  public
    procedure CreateInitialize; override;
    destructor Destroy; override;
    procedure BeginUpdate; override;
    procedure EndUpdate; override;
    function GetNodeFromID(AId: string): TTreeNode;
    function GetNodeElement(ANode: TTreeNode): TJSHTMLElement;
    property Selected: TTreeNode read GetSelected write SetSelected;
  published
    property Align;
    property AlignWithMargins;
    property Anchors;

    property AutoExpand: boolean read FAutoExpand write FAutoExpand;
    property ElementNodeClassName: TElementClassName read FElementNodeClassName write SetElementNodeClassName;
    property ElementNodeSelectedClassName: TElementClassName read FElementNodeSelectedClassName write SetElementNodeSelectedClassName;

    property HeightPercent;
    property HeightStyle;

    property Items: TTreeNodes read FItems write SetItems;
    property Margins;
    property WidthPercent;
    property WidthStyle;
    property OnClick;
    property OnDblClick;
    property OnClickNode: TTreeViewNodeEvent read FOnClickNode write FOnClickNode;
    property OnDblClickNode: TTreeViewNodeEvent read FOnDblClickNode write FOnDblClickNode;
    property OnRenderNode: TTreeViewNodeRenderEvent read FOnRenderNode write FOnRenderNode;
    property OnChange: TTreeViewNodeEvent read FOnChange write FOnChange;
    property OnChanging: TTreeViewNodeAllowEvent read FOnChanging write FOnChanging;

    property OnCollapsed: TTreeViewNodeEvent read FOnCollapsed write FOnCollapsed;
    property OnCollapsing: TTreeViewNodeAllowEvent read FOnCollapsing write FOnCollapsing;
    property OnExpanded: TTreeViewNodeEvent read FOnExpanded write FOnExpanded;
    property OnExpanding: TTreeViewNodeAllowEvent read FOnExpanding write FOnExpanding;
  end;

  TWebTreeView = class(TTreeView);



implementation

uses
  WEBLib.Buttons;

{ TCustomRichEdit }

procedure TCustomRichEdit.CreateInitialize;
begin
  inherited;
  FLines := TStringList.Create;
  FLines.OnChange := DoLinesChange;
  FSelAttributes := TTextAttributes.Create(Self);
  FShowFocus := true;
  FInsertLineBreaks := false;
  Width := 400;
  Height := 300;
end;

function TCustomRichEdit.CanShowFocus: boolean;
begin
  Result := FShowFocus;
end;

function TCustomRichEdit.CreateElement: TJSElement;
begin
  Result := document.createElement('DIV');
  Result.addEventListener('input',@DoHandleInput);
end;

destructor TCustomRichEdit.Destroy;
begin
  FLines.Free;
  inherited;
end;

procedure TCustomRichEdit.DoLinesChange(Sender: TObject);
begin
  UpdateElement;
end;

procedure TCustomRichEdit.SetAutoSize(const Value: Boolean);
begin
  if FAutoSize <> Value then
  begin
    FAutoSize := Value;
    UpdateElement;
  end;
end;

procedure TCustomRichEdit.SetLines(ALines: TStringList);
begin
  FLines.Assign(ALines);
end;

procedure TCustomRichEdit.SetReadOnly(const Value: boolean);
begin
  if FReadOnly <> Value then
  begin
    FReadOnly := Value;
    if Assigned(ElementHandle) then
    begin
      if FReadOnly then
        ElementHandle.contentEditable := 'false'
      else
        ElementHandle.contentEditable := 'true';
    end;

  end;
end;

procedure TCustomRichEdit.SetText(const Value: String);
begin
  FLines.Text := Value;
  UpdateElement;
end;

//function TCustomRichEdit.ElementIFrameHandle: TJSWindow;
function TCustomRichEdit.ElementIFrameHandle: TJSDocument;
//var
//  iframe: TJSHTMLIFrameElement;
begin
  Result := nil;
  if Assigned(ElementHandle) then
  begin
//    iframe := TJSHTMLIFrameElement(document.getElementById(ElementID));
//    if Assigned(iframe) then
//      result := iframe.contentWindow.document;
    Result := document;
  end;
end;

procedure GetTextNodes(node: TJSNode; nodes: TList);
var
  children: TJSNodeList;
  i, j: integer;
  childlist: TList;
begin
  if (node.nodeType = 3) then
    nodes.Add(node)
  else
  begin
    children := node.childNodes;
    childlist := TList.Create;
    for i := 0 to children.length - 1 do 
    begin
      getTextNodes(children[i], childlist);   
      for j := 0 to childlist.count - 1 do
        nodes.Add(childlist[i]);
    end;
    childlist.Free;
  end;
end;

procedure TCustomRichEdit.DoSelectAction(StartPosition, EndPosition: integer);
var
  s: string;
  sstart, send: integer;
  el: TJSElement;
  range: TJSRange;
  textNodes: TList;
  textNode: TJSNode;
  i: integer;
  foundStart: boolean;
  charCount, endCharCount: integer;
  sel: TJSSelection;
begin
  s := ElementID;
  sstart := StartPosition;
  send := EndPosition;

  el := document.getElementById(s);
  if Assigned(el) then
  begin
    range := document.createRange;
    range.selectNodeContents(el);
    textNodes := TList.Create;
    GetTextNodes(el, textNodes);

    foundStart := false;
    charCount := 0;
    endCharCount := 0;

    for i := 0 to textNodes.count - 1 do
    begin
      textNode := TJSNode(textNodes[i]);
      endCharCount := charCount + length(TJSNode(textNode).nodeValue);

      if (not foundStart) and (sstart >= charCount) and ((sstart < endCharCount) or ((sstart = endCharCount) and (i <= textNodes.count))) then
      begin
        range.setStart(textNode, sstart - charCount);
        foundStart := true;
      end;

      if (foundStart) and (send <= endCharCount) then
      begin
        range.setEnd(textNode, send - charCount);
      	break;
      end;
      charCount := endCharCount;
    end;

    sel := document.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);

    textNodes.Free;
  end;
end;

procedure TCustomRichEdit.DoEditAction(ActionString: string);
begin
  if Assigned(ElementIFrameHandle) then
    ElementIFrameHandle.execCommand(ActionString, false);
end;

procedure TCustomRichEdit.DoChange;
begin
  if Assigned(OnChange) then
    OnChange(Self);
end;

procedure TCustomRichEdit.DoEditAction(ActionString: string; Data: string);
begin
  if Assigned(ElementIFrameHandle) then
    ElementIFrameHandle.execCommand(ActionString, false, Data);
end;

procedure TCustomRichEdit.DoHandleInput(Event: TJSEvent);
begin
  DoChange;
end;

procedure TCustomRichEdit.DoLinkAction;
var
  url: string;
begin
  if Assigned(ElementHandle) then
  begin
    url := window.prompt('Enter URL:', 'http://');
    if Assigned(url) then
    begin
      if (url <> '') and (url <> 'http://') and (url <> 'https://') then
        DoEditAction('createLink', url);
      end;
  end;
end;

procedure TCustomRichEdit.DoImageAction;
var
  url: string;
begin
  if Assigned(ElementHandle) then
  begin
    url := window.prompt('Enter Image URL:', 'http://');
    if Assigned(url) then
    begin
      if (url <> '') and (url <> 'http://') and (url <> 'https://') then
        DoEditAction('insertImage', url);	
      end;
  end; 
end;

procedure TCustomRichEdit.UpdateElement;
begin
  inherited;

  if Assigned(ElementIFrameHandle) then
  begin
//    ElementIFrameHandle.designMode := 'On';
//    ElementIFrameHandle.document.open;
//    ElementIFrameHandle.document.write(FLines.Text);
//    ElementIFrameHandle.document.close;
//    ElementIFrameHandle.document.contentEditable = true;
//    ElementIFrameHandle.body.innerHTML := FLines.Text;  
  end;

  if Assigned(ElementHandle) then
  begin
    ElementHandle.innerHTML := FLines.Text;

    if ReadOnly then
      ElementHandle.contentEditable := 'false'
    else
      ElementHandle.contentEditable := 'true';

    ElementHandle.style.setProperty('overflow', 'auto');
    ElementHandle.style.setProperty('padding', '3px');

    if BorderStyle = bsSingle then
      ElementHandle.style.setProperty('border', '1px solid silver')
    else
      ElementHandle.style.setProperty('border', '');
  end;
end;

function TCustomRichEdit.GetText: String;
begin
//  if Assigned(ElementIFrameHandle) then
//    FLines.Text := ElementIFrameHandle.body.innerHTML;

  if Assigned(ElementHandle) then
    FLines.Text := ElementHandle.innerHTML;
  Result := FLines.Text;
end;

function TCustomRichEdit.GetContent: string;
begin
  Result := self.GetText;
end;

function TCustomRichEdit.GetPlainText: String;
begin
  Result := '';
  if Assigned(ElementHandle) then
    Result := ElementHandle.innerText;
end;

procedure TCustomRichEdit.SetSelAttributes(Value: TTextAttributes);
begin
  SelAttributes.Assign(Value);
end;

procedure TCustomRichEdit.SetShowFocus(const Value: boolean);
begin
  if (FShowFocus <> Value) then
  begin
    FShowFocus := Value;
    UpdateElement;
  end;
end;

procedure TCustomRichEdit.Loaded;
var
  doc: TJSDocument;
  el: TJSHTMLElement;
begin
  inherited;

  if Assigned(ElementIFrameHandle) then
  begin
    doc := ElementIFrameHandle;
    el := ElementHandle;
//    el.onwheel := @HandleDoWheel;
    el.onclick := @HandleDoClick;
    el.ondblclick := @HandleDoDblClick;
    el.onmousedown := @HandleDoMouseDown;
    el.onmouseup := @HandleDoMouseUp;
    el.onmousemove := @HandleDoMouseMove;
    el.onkeydown := @HandleDoKeyDown;
    el.onkeyup := @HandleDoKeyUp;
    el.onkeypress := @HandleDoKeyPress;
    el.onfocus := @HandleDoEnter;
    el.onblur := @HandleDoExit;
    doc.onselectionchange := @HandleDoSelectionChange;
  end;
end;

procedure TCustomRichEdit.InsertHTML(HTML: String);
var
  sel: TJSSelection;
  range: TJSRange;
  el: TJSHTMLElement;
  frag: TJSDocumentFragment;
  node, lastNode: TJSNode;
begin
  sel := nil;
  if Focused then
  begin
    sel := document.getSelection;
    range := sel.getRangeAt(0);
    range.deleteContents;
  end
  else
  begin
    range := document.createRange();
    range.setStart(ElementHandle, 0);
    range.setEnd(ElementHandle, 0);
  end;

  el := TJSHTMLElement(document.createElement('div'));
  el.innerHTML := HTML;
  frag := document.createDocumentFragment;
  node := el.firstChild;
  while (node = el.firstChild) do
  begin
    lastNode := frag.appendChild(node);		
    range.insertNode(frag);
  end;

  if Assigned(lastNode) then
  begin
    range := range.cloneRange();
    range.setStartAfter(lastNode);
    range.collapse;
    if  Assigned(sel) then
    begin
      sel.removeAllRanges;
      sel.addRange(range);
    end;
  end;
end;

function TCustomRichEdit.HandleDoSelectionChange(Event: TEventListenerEvent): Boolean;
begin
  if Assigned(Owner) then
  begin
    //reset to a color close to black to avoid being unable to
    //select black as the new color
    (Owner as TRichEditToolBar).TextColor := $000001;
    (Owner as TRichEditToolBar).BackgroundColor := $000001;
  end;

  if Assigned(OnSelectionChange) then
    OnSelectionChange(Self);
  Result := True;
end;

function TCustomRichEdit.HandleDoKeyDown(Event: TJSKeyBoardEvent): Boolean;
begin
  Result := false;

  //Handle Return Key
  if (GetKeyCode(Event.Key) = 13) and InsertLineBreaks then
    InsertHTML('<br>')
  else
  //Handle Tab Key
  if (GetKeyCode(Event.Key) = 9) and WantTabs then
    InsertHTML('<span style=white-space:pre>&#9;</span>')
  else
  begin   
    Result := True;
  end;

  inherited;
end;


{ TTextAttributes }

constructor TTextAttributes.Create(AOwner: TCustomRichEdit);
begin
  inherited Create;
  RichEdit := AOwner;
  FAlignment := taLeftJustify;
  FIsBold := False;
  FIsItalic := False;
  FIsUnderline := False;
  FIsStrikeOut := False;
  FOrderedList := False;
  FUnOrderedList := False;
end;

procedure TTextAttributes.Cut;
begin
  RichEdit.DoEditAction('cut');
end;

procedure TTextAttributes.Copy;
begin
  RichEdit.DoEditAction('copy');
end;

procedure TTextAttributes.Paste;
begin
  RichEdit.DoEditAction('paste');
end;

procedure TTextAttributes.Image;
begin
  RichEdit.DoImageAction;
end;

procedure TTextAttributes.Link;
begin
  RichEdit.DoLinkAction;
end;

procedure TTextAttributes.SetAlignment(Value: TAlignment);
begin
  FAlignment := Value;

  case FAlignment of
    taLeftJustify: RichEdit.DoEditAction('justifyleft');
    taCenter: RichEdit.DoEditAction('justifycenter');
    taRightJustify: RichEdit.DoEditAction('justifyright');
  end;
end;

procedure TTextAttributes.SetBackColor(Value: TColor);
begin
  FColor := Value;
  RichEdit.DoEditAction('hiliteColor', ColorToHtml(Value));
end;

procedure TTextAttributes.SetColor(Value: TColor);
begin
  FColor := Value;
  RichEdit.DoEditAction('foreColor', ColorToHtml(Value));
end;

procedure TTextAttributes.SetName(Value: string);
begin
  FName := Value;
  RichEdit.DoEditAction('fontName', Value);
end;

procedure TTextAttributes.SetOrderedList(Value: Boolean);
begin
  if (FOrderedLIst <> Value) then
    RichEdit.DoEditAction('insertorderedlist');

  FOrderedList := Value;
end;

procedure TTextAttributes.SetUnOrderedList(Value: Boolean);
begin
  if (FUnOrderedLIst <> Value) then
    RichEdit.DoEditAction('insertunorderedlist');

  FUnOrderedList := Value;
end;

procedure TTextAttributes.SetStyle(Value: TFontStyles);
begin
  FStyle := Value;

  if (fsBold in FStyle) and (not FIsBold) then
  begin
    RichEdit.DoEditAction('bold');
    FIsBold := True;
  end;

  if (not(fsBold in FStyle)) and (FIsBold) then
  begin
    RichEdit.DoEditAction('bold');
    FIsBold := False;
  end;
  
  if (fsItalic in FStyle) and (not FIsItalic) then
  begin
    RichEdit.DoEditAction('italic');
    FIsItalic := True;
  end;

  if (not(fsItalic in FStyle)) and (FIsItalic) then
  begin
    RichEdit.DoEditAction('italic');
    FIsItalic := False;
  end;
  
  if (fsUnderline in FStyle) and (not FIsUnderline) then
  begin
    RichEdit.DoEditAction('underline');
    FIsUnderline := True;
  end;

  if (not(fsUnderline in FStyle)) and (FIsUnderline) then
  begin
    RichEdit.DoEditAction('underline');
    FIsUnderline := False;
  end;

  if (fsStrikeOut in FStyle) and (not FIsStrikeOut) then
  begin
    RichEdit.DoEditAction('strikethrough');
    FIsStrikeOut := True;
  end;

  if (not(fsStrikeOut in FStyle)) and (FIsStrikeOut) then
  begin
    RichEdit.DoEditAction('strikethrough');
    FIsStrikeOut := False;
  end;

//  RichEdit.UpdateElement;
end;

procedure TTextAttributes.SetSize(Value: Integer);
begin
  if (Value > 0) and (Value < 8) then
  begin
    FSize := Value;
    FHeight := Value;
    RichEdit.DoEditAction('fontSize', IntToStr(Value));
  end;
end;

procedure TTextAttributes.SetHeight(Value: Integer);
begin
  if (Value > 0) and (Value < 8) then
  begin
    FSize := Value;
    FHeight := Value;
    RichEdit.DoEditAction('fontSize', IntToStr(Value));
  end;
end;

procedure TTextAttributes.Assign(Source: TPersistent);
begin
  if Source is TFont then
  begin
    Color := TFont(Source).Color;
    Name := TFont(Source).Name;
    Style := TFont(Source).Style;
    Size := TFont(Source).Size;
  end
  else if Source is TTextAttributes then
  begin
    Color := TTextAttributes(Source).Color;
    Name := TTextAttributes(Source).Name;
    Style := TTextAttributes(Source).Style;
    Size := TTextAttributes(Source).Size;
  end
  else inherited Assign(Source);
end;

procedure TTextAttributes.AssignTo(Dest: TPersistent);
begin
  if Dest is TFont then
  begin
    TFont(Dest).Color := Color;
    TFont(Dest).Name := Name;
    TFont(Dest).Style := Style;
    TFont(Dest).Size := Size;
  end
  else if Dest is TTextAttributes then
  begin
    TTextAttributes(Dest).Color := Color;
    TTextAttributes(Dest).Name := Name;
    TTextAttributes(Dest).Style := Style;
  end
  else inherited AssignTo(Dest);
end;

{ TTabSet }

procedure TTabSet.BindEvents;
begin
  inherited;
  if Assigned(ElementHandle) then
  begin
    ElementHandle.onchange := @HandleDoChange;
  end;
end;

procedure TTabSet.Clear;
begin
  Items.Clear;
end;

procedure TTabSet.CreateInitialize;
begin
  inherited;
  FItems := TStringList.Create;
  FItems.OnChange := ItemsChanged;
  FItemIndex := 0;
  FSelectedColor := clSilver;
end;

function TTabSet.CreateElement: TJSElement;
begin
  Result := document.createElement('SPAN');
end;

destructor TTabSet.Destroy;
begin
  FItems.Free;
  inherited;
end;

procedure TTabSet.SetItems(AItems: TStringList);
begin
  FItems.Assign(AItems);
end;

function TTabSet.HandleDoChange(Event: TEventListenerEvent): Boolean;
begin
  if Assigned(OnChange) then
    OnChange(Self);
  Result := True;
end;

procedure TTabSet.Loaded;
begin
  inherited;
  DoUpdateList;
end;

procedure TTabSet.SelectNextTab(GoForward: boolean);
begin
  if GoForward then
  begin
    if ItemIndex < Items.Count - 1 then
      ItemIndex := ItemIndex + 1
    else
      ItemIndex := 0;
  end
  else
  begin
    if ItemIndex > 0 then
      ItemIndex := ItemIndex - 1
    else
      ItemIndex := Items.Count - 1;
  end;

end;

procedure TTabSet.SetItemIndex(AIndex: integer);
begin
  if FItemIndex <> AIndex then
  begin
    FItemIndex := AIndex;
    DoUpdateList;
  end;
end;

procedure TTabSet.SetSelectedColor(const Value: TColor);
begin
  if FSelectedColor <> Value then
  begin
    FSelectedColor := Value;
    DoUpdateList;
  end;
end;

procedure TTabSet.DoUpdateList;
var
  i: integer;
  s: string;
  ul, li, a: TJSElement;
begin
  if not Assigned(Container) then
    Exit;

  while Assigned(Container.firstChild) do
    Container.removeChild(Container.firstChild);

  Container['class'] := '';

  ul := document.createElement('UL');
  ul['class'] := ElementClassName;

  if ElementClassName <> '' then
    ul['role'] := 'tablist'
  else
  begin
    (TJSHTMLElement(ul)).style.setProperty('list-style-type', 'none');
    (TJSHTMLElement(ul)).style.setProperty('margin', '0');
    (TJSHTMLElement(ul)).style.setProperty('padding', '0');
    (TJSHTMLElement(ul)).style.setProperty('display', 'inline-block');

//    (TJSHTMLElement(ul)).onmouseout := @HandleDoItemMouseOut;
//    (TJSHTMLElement(ul)).onmouseover := @HandleDoItemMouseOver;
  end;

  Container.appendChild(ul);

  for i := 0 to FItems.Count - 1 do
  begin
    s := FItems[i];

    li := document.createElement('LI');

    if ElementClassName <> '' then
      li['class'] := 'nav-item'
    else
    begin
      (TJSHTMLElement(li)).style.setProperty('float', 'left');
      (TJSHTMLElement(li)).style.setProperty('border-bottom', '1px solid lightgray');
    end;

    SetHTMLElementFont(TJSHTMLElement(li), Font, not ((ElementClassName = '') and (ElementFont = efProperty)));

    ul.appendChild(li);

    if not Enabled then
      a := document.createElement('SPAN')
    else
    begin
      a := document.createElement('A');
      a['href'] := '#' + s;
    end;

    a.innerHTML := s;
    a['id'] := GetID + '_' + IntToStr(i);

    if ElementClassName <> '' then
    begin

      if ItemIndex = i then
        a['class'] := 'nav-link active'
      else
        a['class'] := 'nav-link';
      a['role'] := 'tab';

      a['data-toggle'] := 'tab';
      a['aria-controls'] := s;

      if ItemIndex = i then 
        a['aria-selected'] := 'true'
      else
        a['aria-selected'] := 'false';
    end
    else
    begin
      (TJSHTMLElement(a)).style.setProperty('display', 'block');          
      (TJSHTMLElement(a)).style.setProperty('text-align', 'center');          
      (TJSHTMLElement(a)).style.setProperty('padding', '3px 15px');          
      (TJSHTMLElement(a)).style.setProperty('text-decoration', 'none');    
      (TJSHTMLElement(a)).style.setProperty('min-width', '50px'); 
      
      (TJSHTMLElement(a)).style.setProperty('color', 'inherit');
      (TJSHTMLElement(a)).style.setProperty('font-family', 'inherit');
      (TJSHTMLElement(a)).style.setProperty('font-style', 'inherit');
      (TJSHTMLElement(a)).style.setProperty('font-size', 'inherit');

      if not enabled then
        (TJSHTMLElement(a)).style.setProperty('pointer-events', 'none'); 

      if ItemIndex = i then 
        (TJSHTMLElement(a)).style.setProperty('background-color', ColorToHtml(SelectedColor));
    end;

    li.appendChild(a);
  end;

  if (csDesigning in ComponentState) then
    RenderDesigning('TWebTabSet', Container, Self, (FItems.Count = 0));

  UpdateElement;
end;

procedure TTabSet.EndUpdate;
begin
  inherited;
  DoUpdateList;
end;

function TTabSet.HandleDoClick(Event: TJSMouseEvent): Boolean;
var
  sid: string;
  i: integer;
begin
  sid := event.target['id'];

  if sid <> '' then
  begin
    sid := StringReplace(sid, GetID + '_', '', []);    
    if TryStrToInt(sid,i) then
    begin
      FItemIndex := i;
      DoUpdateList;
    end;
    inherited;
  end;

  Result := true;
end;

function TTabSet.HandleDoItemMouseOut(Event: TJSMouseEvent): Boolean;
var
  el: TJSHTMLElement;
begin
  Result := true;
  //Event.stopPropagation;

  el := TJSHTMLElement(Event.relatedTarget);
  if Assigned(el) then
  begin
    if el.nodeName = 'A' then
      el.style.setProperty('background-color', '');
  end
end;

function TTabSet.HandleDoItemMouseOver(Event: TJSMouseEvent): Boolean;
var
  el: TJSHTMLElement;
begin
  Result := true;
  //Event.stopPropagation;

  el := TJSHTMLElement(Event.relatedTarget);
  if Assigned(el) then
  begin
    if el.nodeName = 'A' then
      el.style.setProperty('background-color', 'lightgray');
  end
end;


procedure TTabSet.ItemsChanged(Sender: TObject);
begin
  DoUpdateList;
end;

{ TPageControl }


procedure TPageControl.BindEvents;
begin
  inherited;
  if Assigned(ElementHandle) then
  begin
    //The ElementHandle doesn't have an onchange event
    //so the onclick is used instead.
    //HandleDoChange checks if a different tab is clicked
    ElementHandle.onclick := @HandleDoChange;
  end;
end;

procedure TPageControl.Clear;
begin
  Items.Clear;
end;

procedure TPageControl.CreateInitialize;
begin
  inherited;
  FItems := TStringList.Create;
  FTabIndex := 0;
  FPrevTabIndex := FTabIndex;
  TabStop := false;
  FSelectedColor := clSilver;
  Width := 400;
  Height := 300;
end;

function TPageControl.CreateElement: TJSElement;
begin
  Result := document.createElement('SPAN');
end;

destructor TPageControl.Destroy;
begin
  FItems.Free;
  inherited;
end;

procedure TPageControl.SelectNextPage(GoForward: boolean);
begin
  if GoForward then
  begin
    if TabIndex < PageCount - 1 then
      TabIndex := TabIndex + 1
    else
      TabIndex := 0;
  end
  else
  begin
    if TabIndex > 0 then
      TabIndex := TabIndex - 1
    else
      TabIndex := PageCount - 1;
  end;
end;

function TPageControl.PageCount: integer;
var
  i: integer;
begin
  Result := 0;

  for i := 0 to ControlCount - 1 do
  begin
    if (Controls[i] is TTabSheet) then
      inc(Result);
  end;
end;


function TPageControl.GetPage(index: integer): TTabSheet;
var
  c,i: integer;
begin
  c := -1;
  Result := nil;

  for i := 0 to ControlCount - 1 do
  begin
    if (Controls[i] is TTabSheet) then
      inc(c);

     if c = index then
     begin
       Result := Controls[i] as TTabSheet;
       break;
     end;
  end;
end;


procedure TPageControl.SetItems(AItems: TStringList);
begin
  FItems.Assign(AItems);
end;

function TPageControl.HandleDoChange(Event: TJSMouseEvent): Boolean;
begin
  if FPrevTabIndex <> FTabIndex then
  begin
    FPrevTabIndex := FTabIndex;
    if Assigned(OnChange) then
      OnChange(Self);
  end;
  Result := True;
end;

procedure TPageControl.Loaded;
begin
  inherited;
  DoUpdateList;
end;

procedure TPageControl.SetTabIndex(AIndex: integer);
begin
  if (FTabIndex <> AIndex) and (AIndex >= 0) then
  begin
    FTabIndex := AIndex;
    FPrevTabIndex := FTabIndex;
    DoUpdateList;
  end;
end;

procedure TPageControl.SetSelectedColor(const AValue: TColor);
begin
  if FSelectedColor <> AValue then
  begin
    FSelectedColor := AValue;
    DoUpdateList;
  end;
end;

procedure TPageControl.DoUpdateList;
var
  i: integer;
  s: string;
  shidden: string;
  n: TJSNode;
  ul, li, a: TJSElement;
  tabs: TStringList;
  tab: TTabSheet;

begin
  if not Assigned(Container) then
    Exit;

  if not Assigned(ElementHandle) or IsUpdating then
    Exit;

  if ControlCount > 0 then
  begin

    tabs := TStringList.Create;

    shidden := '{#hidden#}';

    for i := 0 to ControlCount - 1 do
    begin
      if Controls[i] is TTabSheet then
      begin
        tab := TTabSheet(Controls[i]);
        if tab.TabVisible then
          tabs.Add(tab.FTabCaption)
        else
          tabs.Add(shidden);
        tab.Align := alClient;
        tab.AlignWithMargins := True;
        tab.Margins.Left := 0;
        tab.BorderStyle := bsSingle;
        tab.Visible := (TabIndex = i);
        tab.GetElementHandle.style.setProperty('background-color', ColorToHtml(tab.Color));
      end;
    end;

    for i := 0 to Container.childNodes.length - 1 do
    begin
      n := Container.childNodes[i];
      if Assigned(n) and (TJSElement(n)['id'] = GetID + '_UL') then
        Container.removeChild(n);
    end;

    Container['class'] := '';

    if not Enabled then
      ElementHandle.style.setProperty('pointer-events', 'none')
    else
      ElementHandle.style.setProperty('pointer-events', 'auto');

    ul := document.createElement('UL');
    ul['class'] := ElementClassName;
    ul['id'] := GetID + '_UL';

    if ElementClassName <> '' then
      ul['role'] := 'tablist'
    else
    begin
      (TJSHTMLElement(ul)).style.setProperty('list-style-type', 'none');
      (TJSHTMLElement(ul)).style.setProperty('margin', '0');
      (TJSHTMLElement(ul)).style.setProperty('padding', '0');
      (TJSHTMLElement(ul)).style.setProperty('display', 'inline-block');
    end;

    Container.appendChild(ul);

    for i := 0 to tabs.Count - 1 do
    begin
      s := tabs[i];
      if s <> shidden then
      begin
        if s = '' then
          s := 'tab' + IntToStr(i);

        li := document.createElement('LI');

        if ElementClassName <> '' then
          li['class'] := 'nav-item'
        else
        begin
          (TJSHTMLElement(li)).style.setProperty('float', 'left');
          if BorderStyle <> bsNone then
            (TJSHTMLElement(li)).style.setProperty('border-bottom', '1px solid lightgray');
        end;

        SetHTMLElementFont(TJSHTMLElement(li), Font, not ((ElementClassName = '') and (ElementFont = efProperty)));

        ul.appendChild(li);

        if not Enabled then
          a := document.createElement('SPAN')
        else
        begin
          a := document.createElement('A');
          a['href'] := '#' + s;
        end;

        a.innerHTML := s;
        a['id'] := GetID + '_' + IntToStr(i);

        if ElementClassName <> '' then
        begin
          if TabIndex = i then
            a['class'] := 'nav-link active'
          else
            a['class'] := 'nav-link';
          a['role'] := 'tab';

          a['data-toggle'] := 'tab';
          a['aria-controls'] := s;

          if TabIndex = i then
            a['aria-selected'] := 'true'
          else
            a['aria-selected'] := 'false';
        end
        else
        begin
          (TJSHTMLElement(a)).style.setProperty('display', 'block');
          (TJSHTMLElement(a)).style.setProperty('text-align', 'center');
          (TJSHTMLElement(a)).style.setProperty('padding', '3px 15px');
          (TJSHTMLElement(a)).style.setProperty('text-decoration', 'none');
          (TJSHTMLElement(a)).style.setProperty('min-width', '50px');

          (TJSHTMLElement(a)).style.setProperty('color', 'inherit');
          (TJSHTMLElement(a)).style.setProperty('font-family', 'inherit');
          (TJSHTMLElement(a)).style.setProperty('font-style', 'inherit');
          (TJSHTMLElement(a)).style.setProperty('font-size', 'inherit');

          if not enabled then
            (TJSHTMLElement(a)).style.setProperty('pointer-events', 'none');

          if TabIndex = i then
            (TJSHTMLElement(a)).style.setProperty('background-color', ColorToHtml(SelectedColor));
        end;

        li.appendChild(a);
      end;
    end;

    for i := 0 to ControlCount - 1 do
    begin
      if Controls[i] is TTabSheet then
      begin
        TTabSheet(Controls[i]).Margins.Top := Round((TJSHTMLElement(ul)).offsetHeight) - 1;
        TTabSheet(Controls[i]).ElementHandle.style.setProperty('white-space', '');
        TTabSheet(Controls[i]).BorderStyle := BorderStyle;
      end;
    end;

    tabs.Free;
  end
  else
  begin
    if (csDesigning in ComponentState) then
      RenderDesigning('TWebPageControl', Container, Self, True);
  end;

  UpdateElement;
end;

procedure TPageControl.EndUpdate;
begin
  inherited;
  DoUpdateList;
end;

function TPageControl.HandleDoClick(Event: TJSMouseEvent): Boolean;
var
  sid: string;
  i: integer;
begin
  sid := Event.target['id'];

  if sid <> '' then
  begin
    sid := StringReplace(sid, GetID + '_', '', []);    
    if TryStrToInt(sid,i) then
    begin
      FTabIndex := i;
      DoUpdateList;
    end;
    inherited;
  end;

  Result := true;
end;

function TPageControl.HandleDoItemMouseOut(Event: TJSMouseEvent): Boolean;
var
  el: TJSHTMLElement;
begin
  Result := true;
  //Event.stopPropagation;

  el := TJSHTMLElement(Event.relatedTarget);
  if Assigned(el) then
  begin
    if el.nodeName = 'A' then
      el.style.setProperty('background-color', '');
  end
end;

function TPageControl.HandleDoItemMouseOver(Event: TJSMouseEvent): Boolean;
var
  el: TJSHTMLElement;
begin
  Result := true;
  //Event.stopPropagation;

  el := TJSHTMLElement(Event.relatedTarget);
  if Assigned(el) then
  begin
    if el.nodeName = 'A' then
      el.style.setProperty('background-color', 'lightgray');
  end
end;

{ TTabSheet }

procedure TTabSheet.CreateInitialize;
begin
  inherited;
  EnablePropagation := true;
  ControlStyle := ControlStyle + [csAcceptsControls];
  Color := clWhite;
  TabVisible := True;
  ShowCaption := False;
end;

procedure TTabSheet.SetCaption(const AValue: string);
begin
  if (FTabCaption <> AValue) then
  begin
    FTabCaption := AValue;
    if Assigned(Parent) then
    begin
      if Parent is TPageControl then
        (Parent as TPageControl).DoUpdateList;
    end;
  end;
end;

procedure TTabSheet.SetTabVisible(const Value: Boolean);
begin
  if FTabVisible <> Value then
  begin
    FTabVisible := Value;

    if Assigned(Parent) then
    begin
      if Parent is TPageControl then
        (Parent as TPageControl).DoUpdateList;
    end;
  end;
end;

{ TProgressBar }

procedure TProgressBar.CreateInitialize;
begin
  inherited;
  FMax := 100;
  FMin := 0;
  FPosition := 0;
  FStyle := pbstNormal;
end;

procedure TProgressBar.CreateProgressElement(AElement: TJSElement);
var
  d: TJSElement;
begin
  while Assigned(AElement.firstChild) do
    AElement.removeChild(AElement.firstChild);

  if FStyle = pbstDiv then
  begin
    d := document.createElement('DIV');
    d.appendChild(document.createElement('DIV'));
  end
  else
    d := document.createElement('PROGRESS');

  AElement.appendChild(d);
end;

procedure TProgressBar.AfterLoadDFMValues;
begin
  inherited;
  DoUpdate;
end;

function TProgressBar.CreateElement: TJSElement;
begin
  Result := document.createElement('SPAN');
  CreateProgressElement(Result);
end;

procedure TProgressBar.SetElementBarClassName(const Value: string);
begin
  FElementBarClassName := Value;
  DoUpdate;
end;

procedure TProgressBar.SetMax(AValue: integer);
begin
  FMax := AValue;
  DoUpdate;
end;

procedure TProgressBar.SetMin(AValue: integer);
begin
  FMin := AValue;
  DoUpdate;
end;

procedure TProgressBar.DoUpdate;
var
  pvalue: integer;
  maxvalue: integer;
  el: TJSHTMLElement;
  pos: integer;
begin
  if not Assigned(Container) then
    Exit;

  if FMax <> FMin then
    pos := Round((FPosition - Min) / (Max - Min) * 100)
  else
    pos := 0;

  //
  if isLinked then
  begin
    if ElementHandle.TagName= 'DIV' then
    begin
      if ElementHandle['role'] = 'progressbar' then
        ElementHandle.style.setProperty('width',inttostr(pos)+'%')
      else
        ElementHandle.innerHTML := inttostr(pos)
    end
    else
      ElementHandle.setAttribute('value',inttostr(pos));

    Exit;
  end;


  if Style = pbstDiv then
  begin

    el := TJSHTMLElement(ElementHandle.firstChild);

    if ElementClassName <> '' then
    begin
      el.setAttribute('class',ElementClassName);
      ElementHandle.removeAttribute('class');
    end;

    el.style.setProperty('height',inttostr(Height)+'px');

    if WidthStyle = ssAbsolute then
      el.style.setProperty('width',inttostr(Width)+'px');

    el := TJSHTMLElement(el.firstChild);

    if ElementBarClassName <> '' then
      el.setAttribute('class',ElementBarClassName);

    el.setAttribute('role','progressbar');
    el.style.setProperty('width',inttostr(pos)+'%');

    case Value of
    pbvPercentage: el.innerHTML := inttostr(pos)+'%';
    pbvAbsolute: el.innerHTML := inttostr(Position);
    pbvNone: el.innerHTML := '';
    end;
  end
  else
  begin
    el := TJSHTMLElement(ElementHandle.firstChild);
    el.style.setProperty('width','100%');
    el.style.setProperty('height','100%');
    pvalue := FPosition - FMin;
    maxvalue := FMax - FMin;
    el['max'] := IntToStr(maxvalue);

    if Style = pbstNormal then
      el['value'] := IntToStr(pvalue)
    else
      el.removeAttribute('value');
  end;
end;

procedure TProgressBar.SetPosition(AValue: integer);
begin
  if (FPosition >= Min) and (FPosition <= Max) then
  begin
    FPosition := AValue;
    DoUpdate;
  end;
end;

procedure TProgressBar.SetStyle(const Value: TProgressBarStyle);
begin
  if FStyle <> Value then
  begin
    FStyle := Value;

    if Assigned(ElementHandle) then
    begin
      CreateProgressElement(ElementHandle);
      DoUpdate;
    end;
  end;
end;

procedure TProgressBar.SetValue(const Value: TProgressBarValue);
begin
  FValue := Value;
  DoUpdate;
end;

{ TWebTreeView }

procedure TTreeView.BeginUpdate;
begin
  inherited;
end;

function TTreeView.CreateElement: TJSElement;
var
  tn: TTreeNode;
begin
  if (csDesigning in ComponentState) then
  begin
    BeginUpdate;

    tn := Items.Add('<font color="#E5413C" style="font-size:10pt">&#x25FC;</font> Item 1');
    Items.AddChild(tn,'Child Item 1');

    tn := Items.Add('<font color="#F39527" style="font-size:10pt">&#x25FC;</font> Item 2');
    Items.AddChild(tn,'Child Item 2');

    tn := Items.Add('<font color="#BDC6CB" style="font-size:10pt">&#x25FC;</font> Item 3');
    Items.AddChild(tn,'Child Item 3');

    EndUpdate;
  end;

  Result := document.createElement('DIV');
end;

procedure TTreeView.CreateInitialize;
var
  css: string;
begin
  inherited;
  FSelected := nil;
  FItems := TTreeNodes.Create(Self);
  FItems.OnChange := DoNodesChanged;
  FItems.OnExpandedChange := DOExpandedChanged;

  // remove default bullets
  css := '.TVUL {' +
    ' list-style-type: none;' +
    ' margin: 0;' +
    ' padding-left: 15px;' +
    '}' + #13#10 +

    ' .TVCARET {' +
    '  cursor: pointer;' +
    '  user-select: none;' +
    '}' + #13#10 +

    '.TVCARET::before {' +
    'content: "\25B6";' +
    'color: black;' +
    'display: inline-block;' +
    'margin-right: 6px;' +
    '}' + #13#10 +

    '.TVCARET-DOWN::before {'+
    'transform: rotate(90deg);'+
    '}'+ #13#10 +

    '.TVNESTED {' +
    '  display: none;' +
    '}' + #13#10 +

    '.TVACTIVE {' +
    '  display: block;' +
    '}' + #13#10 +

    '.TVNODE {' +
    ' padding: 3px;'+
    ' display: inline-block;' +
    '}' + #13#10 +

    '.TVNOCURSOR {' +
    ' cursor: initial;'+
    '}' + #13#10 +

    '.TVSELECTED {' +
    '  background-color: #0000ff;' +
    '  color: #ffffff;' +
    '}';

  AddControlStyle(css);
end;

destructor TTreeView.Destroy;
begin
  FItems.Free;
  inherited;
end;

procedure TTreeView.DoChangeSelection(NewNode: TTreeNode);
var
  Allow: boolean;
begin
  Allow := true;

  if Assigned(OnChanging) then
    OnChanging(Self, NewNode, Allow);

  if Allow then
  begin
    Selected := NewNode;
    if Assigned(OnChange) then
      OnChange(Self, NewNode);
  end;
end;

procedure TTreeView.DoExpandedChanged(Sender: TObject; ANode: TTreeNode);
var
  el, su: TJSElement;
begin
  if ANode.Count > 0 then
  begin
    el := GetNodeElement(ANode);

    if Assigned(el) and Assigned(el.parentElement) and Assigned(el.parentElement.parentElement) then
    begin
      su := el.parentElement.parentElement.querySelector('.TVNESTED');
      if Assigned(su) then
      begin
        su.classList.toggle('TVACTIVE');
        el.parentElement.classList.toggle('TVCARET-DOWN');
      end;
    end;
  end;
end;

procedure TTreeView.DoNodesChanged(Sender: TObject);
begin
  //
end;

procedure TTreeView.DoRenderNode(ANode: TTreeNode; AElement: TJSHTMLElement);
begin
  if Assigned(OnRenderNode) then
    OnRenderNode(Self, ANode, AElement);
end;

procedure TTreeView.EndUpdate;
begin
  inherited;
  Selected := nil;
  RenderNodes;
end;

function TTreeView.GetNodeElement(ANode: TTreeNode): TJSHTMLElement;
var
  s: string;
  tn: TTreeNode;
begin
  Result := nil;
  tn := ANode;

  if not Assigned(tn) then
    Exit;

  s := '';

  // generate HTML element ID
  repeat
    if s = '' then
      s := IntToStr(tn.Index)
    else
      s := IntTostr(tn.Index) + '_' + s;

    tn := tn.Parent;

//  until (tn = nil);
  until (not Assigned(tn));

  s := Name + '_' + s;

  Result := TJSHTMLElement(document.getElementById(s));

  if Assigned(Result) then
  begin
    if Result.classlist.contains('TVCARET') then
      Result := TJSHTMLElement(Result.firstChild);
  end;
end;

function TTreeView.GetNodeFromID(AId: string): TTreeNode;
var
  s: string;
  sl: TStringList;
  n: TTreeNode;
  i,j,e: integer;

begin
  Result := nil;

  s := AID;
  s := Copy(s, Length(Name) + 2, Length(s));

  if (s <> '') then
  begin
    sl := TStringList.Create;
    sl.Delimiter := '_';
    sl.StrictDelimiter := true;
    sl.DelimitedText := s;

    n := nil;
    for i := 0 to sl.Count - 1 do
    begin
      val(sl.Strings[i], j, e);

      if (i = 0) then
        n  := Items[j]
      else
        n := n.Item[j];
    end;
    sl.Free;

    Result := n;
  end;
end;

function TTreeView.GetSelected: TTreeNode;
begin
  Result := FSelected;
end;

function TTreeView.HandleClick(Event: TJSEvent): Boolean;
var
  n: TTreeNode;
  el: TJSHTMLElement;
begin
  Result := true;
  asm
    el = Event.srcElement;
  end;

  if Assigned(el) then
  begin
    if el.hasAttribute('id') then
    begin
      n := GetNodeFromID(el['id']);

      if Assigned(OnClick) then
        OnClick(Self);

      if Assigned(n) then
      begin
        DoChangeSelection(n);

        if Assigned(OnClickNode) then
          OnClickNode(Self, n);
      end;
    end;

  end;
end;

function TTreeView.HandleDblClick(Event: TJSEvent): Boolean;
var
  n: TTreeNode;
  el: TJSElement;
begin
  Result := true;
  asm
    el = Event.srcElement;
  end;

  if Assigned(el) then
  begin
    if el.hasAttribute('id') then
    begin
      n := GetNodeFromID(el['id']);

      if Assigned(OnDblClick) then
        OnDblClick(Self);

      if Assigned(n) and Assigned(OnDblClickNode) then
        OnDblClickNode(Self, n);
    end;
  end;

end;

function TTreeView.HandleNode(Event: TJSEvent): Boolean;
var
  el: TJSElement;
  n: TTreeNode;
  Allow: boolean;
begin
  asm
    el = Event.srcElement;
  end;

  if Assigned(el) and (el.hasAttribute('id')) then
  begin
    n := GetNodeFromID(el['id']);

    Allow := true;

    if n.Expanded then
    begin
      if Assigned(OnCollapsing) then
        OnCollapsing(Self, n, Allow);
    end
    else
    begin
      if Assigned(OnExpanding) then
        OnExpanding(Self, n, Allow);
    end;

    if Allow then
    begin
      n.Expanded := not n.Expanded;

      if n.Expanded then
      begin
        if Assigned(OnExpanded) then
          OnExpanded(Self, n);
      end
      else
      begin
        if Assigned(OnCollapsed) then
          OnCollapsed(Self, n);
      end;
    end;

    DoChangeSelection(n);

    if Assigned(OnClickNode) then
      OnClickNode(Self, n);

    Result := true;
    Event.preventDefault;
  end
  else
  begin
    if Assigned(el) then
    begin
      el := el.parentElement;
      if el.hasAttribute('id') then
      begin
        n := GetNodeFromID(el['id']);
        DoChangeSelection(n);

        if Assigned(OnClickNode) then
          OnClickNode(Self, n);

        Result := true;
        Event.preventDefault;
      end;
    end;

  end;



end;

procedure TTreeView.KeyDown(var Key: Word; Shift: TShiftState);
var
  tn,sn,ln: TTreeNode;
begin
  tn := Selected;

  if (Key = VK_HOME) then
  begin
    if Assigned(Items[0]) then
      DoChangeSelection(Items[0]);
  end;

  if (Key = VK_END) and (Items.Count > 0) then
  begin
    tn := Items[Items.Count - 1];

    while tn.Expanded do
    begin
      if tn.Count > 0 then
        tn := tn.Item[tn.Count -1];
    end;

    DoChangeSelection(tn);
  end;

  if (Key = VK_DOWN) then
  begin
    if Assigned(tn) then
    begin
      if tn.Expanded and (tn.Count > 0) then
      begin
        tn := tn.GetFirstChild;
      end
      else
        tn := tn.GetNextSibling;

      if not Assigned(tn) then
      begin
        tn := Selected;
        sn := tn;

        while not Assigned(sn.GetNextSibling) and Assigned(sn.Parent) do
        begin
          sn := sn.Parent;
          if Assigned(sn) then
            ln := sn.GetNextSibling;

          if Assigned(ln) then
          begin
            tn := ln;
          end;
        end;
      end;

      if Assigned(tn) then
        DoChangeSelection(tn);
    end;
  end;

  if (Key = VK_UP) then
  begin
    if Assigned(tn) then
    begin
      tn := tn.GetPrevSibling;
      if Assigned(tn) then
      begin
        sn := tn;
        while Assigned(sn) and sn.Expanded and (sn.Count > 0) do
        begin
          sn := sn.Item[tn.Count - 1];
          if Assigned(sn) then
            tn := sn;
        end;

        DoChangeSelection(tn);
      end
      else
      begin
        tn := Selected.Parent;
        if Assigned(tn) then
          DoChangeSelection(tn);
      end;
    end;
  end;

  if (Key = VK_RIGHT) then
  begin
    if Assigned(tn) then
      Selected.Expanded := true;
  end;

  if (Key = VK_LEFT) then
  begin
    if Assigned(tn) then
      Selected.Expanded := false;
  end;

  if (Key in [VK_LEFT, VK_RIGHT, VK_DOWN, VK_UP]) then
  begin
    Key := 0;
    Exit;
  end;


  inherited;
end;

function TTreeView.RenderNode(ANode: TTreeNode; AElementName: string): TJSHTMLElement;
begin
  Result := TJSHTMLElement(document.createElement('SPAN'));
  if AElementName <> '' then
    Result.setAttribute('id',AElementName);

  Result.innerHTML := ANode.Text;
  Result.classlist.add('TVNODE');

  if ElementNodeClassName <> '' then
    Result.classlist.add(ElementNodeClassName);

  if Assigned(Selected) then
  begin
    if Selected = ANode then
    begin
      Result.classlist.add('TVSELECTED');
      if ElementNodeSelectedClassName <> '' then
        Result.classlist.add(ElementNodeSelectedClassName);
    end;
  end;

//  if not Assigned(OnClickNode) and not Assigned(OnDblClickNode) then
//    Result.style.setProperty('pointer-events','none');

  if ANode.Hint <> '' then
    Result.setAttribute('title', ANode.Hint);
end;

procedure TTreeView.RenderNodes;

  procedure RenderChildNode(LinkElement: TJSHTMLElement; ANode: TTreeNode; AElementName: string);
  var
    sp,nd: TJSHTMLElement;
  begin
    sp := TJSHTMLElement(document.createElement('SPAN'));
    if AElementName <> '' then
      sp.setAttribute('id', AElementName);
    sp.addEventListener('click',@HandleNode);

    nd := TJSHTMLElement(document.createElement('SPAN'));

    if AutoExpand then
      nd.style.setProperty('pointer-events', 'none');

    nd.innerHTML := ANode.Text;
    nd.classlist.add('TVNODE');

    if ElementNodeClassName <> '' then
      nd.classlist.add(ElementNodeClassName);


    if not AutoExpand then
      nd.classlist.add('TVNOCURSOR');

    if Assigned(Selected) then
    begin
      if Selected = ANode then
      begin
        nd.classlist.add('TVSELECTED');
        if ElementNodeSelectedClassName <> '' then
          nd.classlist.add(ElementNodeSelectedClassName);
      end;
    end;

    if ANode.Hint <> '' then
      nd.setAttribute('title', ANode.Hint);

    LinkElement.appendChild(sp);
    sp.appendChild(nd);
    if ANode.Expanded then
      sp.setAttribute('class', 'TVCARET TVCARET-DOWN')
    else
      sp.setAttribute('class', 'TVCARET');

    DoRenderNode(ANode, nd);
  end;

  procedure FillChilds(ParentElement: TJSElement; ParentName: string; ANode: TTreeNode);
  var
    i: integer;
    ul: TJSElement;
    nd,li: TJSHTMLElement;
    nn: string;
  begin
    ul := document.createElement('UL');
    ul.setAttribute('class','TVUL');
    ul.setAttribute('id',ParentName);
    ParentElement.appendChild(ul);

    if not Assigned(ANode) then
    begin
      // root items
      for i := 0 to FItems.Count - 1 do
      begin
        nn := ParentName + '_' + inttostr(i);

        li := TJSHTMLElement(document.createElement('LI'));
        ul.appendChild(li);

        if FItems[i].Count > 0 then
        begin
          RenderChildNode(li, FItems[i], nn);
          FillChilds(li, nn, FItems[i]);
        end
        else
        begin
          nd := RenderNode(FItems[i], nn);
          li.appendChild(nd);
          DoRenderNode(FItems[i], nd);

          nd.addEventListener('click', @HandleClick);
          if Assigned(OnDblClickNode) then
            nd.addEventListener('dblclick', @HandleDblClick);
        end;
      end;
    end
    else
    begin
      // child items
      if ANode.Expanded then
        ul.setAttribute('class','TVNESTED TVUL TVACTIVE')
      else
        ul.setAttribute('class','TVNESTED TVUL');

      for i := 0 to ANode.Count - 1 do
      begin
        nn := ParentName + '_' + inttostr(i);

        li := TJSHTMLElement(document.createElement('LI'));
        ul.appendChild(li);

        if ANode.Item[i].Count > 0 then
        begin
          RenderChildNode(li, ANode.Item[i], nn);
          FillChilds(li, nn, ANode.Item[i]);
        end
        else
        begin
          nd := RenderNode(ANode.Item[i], nn);
          li.appendChild(nd);

          DoRenderNode(ANode.Item[i], nd);

          nd.addEventListener('click', @HandleClick);

          if Assigned(OnDblClickNode) then
            nd.addEventListener('dblclick', @HandleDblClick);
        end;
      end;
    end;
  end;

begin
  if not Assigned(ElementHandle) then
    Exit;

  // remove previous tree
  while ElementHandle.childNodes.length > 0 do
    ElementHandle.removeChild(ElementHandle.FirstChild);

  FillChilds(ElementHandle, Name, nil);
  ElementHandle.style.setProperty('overflow','auto');
end;

procedure TTreeView.SetElementNodeClassName(const Value: TElementClassName);
begin
  if (FElementNodeClassName <> Value) then
  begin
    FElementNodeClassName := Value;
    UpdateElement;
  end;
end;

procedure TTreeView.SetElementNodeSelectedClassName(
  const Value: TElementClassName);
begin
  if (FElementNodeSelectedClassName <> Value) then
  begin
    FElementNodeSelectedClassName := Value;
    UpdateElement;
  end;
end;

procedure TTreeView.SetItems(const Value: TTreeNodes);
begin
  FItems.Assign(Value);
end;

procedure TTreeView.SetSelected(const Value: TTreeNode);
var
  el: TJSHTMLElement;
begin
  if Assigned(FSelected) then
  begin
    el := GetNodeElement(FSelected);
    if Assigned(el) then
    begin
      el.classlist.toggle('TVSELECTED');
      if ElementNodeSelectedClassName <> '' then
        el.classlist.toggle(ElementNodeSelectedClassName);
    end;
  end;

  FSelected := Value;
  el := GetNodeElement(FSelected);
  if Assigned(el) then
  begin
    el.classlist.toggle('TVSELECTED');
    if ElementNodeSelectedClassName <> '' then
      el.classlist.toggle(ElementNodeSelectedClassName);
  end;
end;

end.